import type { FC } from 'react'

import alrajhi_cash_biz from '@/assets/images/alrajhi_cash_biz.svg'

interface LoginLinkProps {
  showLoginDropdown?: boolean
}

const LoginLink: FC<LoginLinkProps> = ({ showLoginDropdown }) => {
  return (
    <div>
      {showLoginDropdown ? (
        <a
          href="https://www.alrajhicashbiz24seven.com.my/iportalweb/CBXLogin.jsp"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={alrajhi_cash_biz.src}
            width={220}
            height={48}
            alt="Login to alrajhicashbiz@24seven Cash Management Business-i"
          />
        </a>
      ) : null}
    </div>
  )
}

export default LoginLink
